module.exports = __webpack_public_path__ + "img/20250207-01-02.d80c7c14.png";